/**
 * Web entry — counterpart to index.js for the React Native Web build.
 *
 * AppRegistry.runApplication mounts the same <App /> into #root. Webpack
 * aliases `react-native` → `react-native-web`, and `babel-plugin-react-native-web`
 * rewrites named imports for tree-shaking.
 */
import 'react-native-get-random-values';
import { AppRegistry } from 'react-native';

import App from './App';
import { name as appName } from './app.json';

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
